/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';

const WarehouseIcon = (props) => (
  <svg
    width={84}
    height={84}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <circle cx={42} cy={42} r={42} fill="#F15C2F" />
    <g clipPath="url(#a)">
      <path d="M22.693 38.358h3.374v3.374h-3.374V38.36Z" fill="url(#b)" />
      <path d="M22.693 38.358h3.374v3.374h-3.374V38.36Z" fill="#fff" />
      <path
        d="M42.937 56.072a.844.844 0 0 1-.843.843h-5.061a.843.843 0 0 1-.844-.843v-4.218h-3.374v11.809h13.496V51.854h-3.374v4.218Zm1.687 5.904h-1.687v-1.687h1.687v1.687Z"
        fill="url(#c)"
      />
      <path
        d="M42.937 56.072a.844.844 0 0 1-.843.843h-5.061a.843.843 0 0 1-.844-.843v-4.218h-3.374v11.809h13.496V51.854h-3.374v4.218Zm1.687 5.904h-1.687v-1.687h1.687v1.687Z"
        fill="#fff"
      />
      <path d="M37.876 51.854h3.374v3.374h-3.374v-3.374Z" fill="url(#d)" />
      <path d="M37.876 51.854h3.374v3.374h-3.374v-3.374Z" fill="#fff" />
      <path
        d="M27.754 42.576a.843.843 0 0 1-.843.843H21.85a.843.843 0 0 1-.844-.843v-4.218h-3.373v11.81h13.495v-11.81h-3.374v4.218Zm1.687 5.904h-1.687v-1.687h1.687v1.687Z"
        fill="url(#e)"
      />
      <path
        d="M27.754 42.576a.843.843 0 0 1-.843.843H21.85a.843.843 0 0 1-.844-.843v-4.218h-3.373v11.81h13.495v-11.81h-3.374v4.218Zm1.687 5.904h-1.687v-1.687h1.687v1.687Z"
        fill="#fff"
      />
      <path
        d="M32.815 50.167h14.34a.843.843 0 0 1 .843.844v12.652h7.591V45.106H32.815v5.061Z"
        fill="url(#f)"
      />
      <path
        d="M32.815 50.167h14.34a.843.843 0 0 1 .843.844v12.652h7.591V45.106H32.815v5.061Z"
        fill="#fff"
      />
      <path
        d="M27.754 56.072a.844.844 0 0 1-.843.843H21.85a.843.843 0 0 1-.844-.843v-4.218h-3.373v11.809h13.495V51.854h-3.374v4.218Zm1.687 5.904h-1.687v-1.687h1.687v1.687Z"
        fill="url(#g)"
      />
      <path
        d="M27.754 56.072a.844.844 0 0 1-.843.843H21.85a.843.843 0 0 1-.844-.843v-4.218h-3.373v11.809h13.495V51.854h-3.374v4.218Zm1.687 5.904h-1.687v-1.687h1.687v1.687Z"
        fill="#fff"
      />
      <path d="M22.693 51.854h3.374v3.374h-3.374v-3.374Z" fill="url(#h)" />
      <path d="M22.693 51.854h3.374v3.374h-3.374v-3.374Z" fill="#fff" />
      <path
        d="M38.72 24.863a.845.845 0 0 0 .843.843h3.374a.843.843 0 0 0 0-1.687h-3.374a.844.844 0 0 0-.844.844Z"
        fill="url(#i)"
      />
      <path
        d="M38.72 24.863a.845.845 0 0 0 .843.843h3.374a.843.843 0 0 0 0-1.687h-3.374a.844.844 0 0 0-.844.844Z"
        fill="#fff"
      />
      <path d="M26.91 31.61h28.68v1.688H26.91V31.61Z" fill="url(#j)" />
      <path d="M26.91 31.61h28.68v1.688H26.91V31.61Z" fill="#fff" />
      <path
        d="M20.163 24.073v12.599h5.06v-5.905a.843.843 0 0 1 .844-.843h30.366a.843.843 0 0 1 .843.843v32.896h5.061v-39.59l-21.087-5.09-21.087 5.09Zm25.304.79a2.533 2.533 0 0 1-2.53 2.53h-3.374a2.53 2.53 0 0 1 0-5.06h3.374a2.534 2.534 0 0 1 2.53 2.53Z"
        fill="url(#k)"
      />
      <path
        d="M20.163 24.073v12.599h5.06v-5.905a.843.843 0 0 1 .844-.843h30.366a.843.843 0 0 1 .843.843v32.896h5.061v-39.59l-21.087-5.09-21.087 5.09Zm25.304.79a2.533 2.533 0 0 1-2.53 2.53h-3.374a2.53 2.53 0 0 1 0-5.06h3.374a2.534 2.534 0 0 1 2.53 2.53Z"
        fill="#fff"
      />
      <path d="M32.815 41.732H55.59v1.687H32.815v-1.687Z" fill="url(#l)" />
      <path d="M32.815 41.732H55.59v1.687H32.815v-1.687Z" fill="#fff" />
      <path
        d="m41.25 15.609-23.617 5.7v1.64l23.42-5.654a.84.84 0 0 1 .395 0l23.42 5.653V21.31L41.25 15.609Z"
        fill="url(#m)"
      />
      <path
        d="m41.25 15.609-23.617 5.7v1.64l23.42-5.654a.84.84 0 0 1 .395 0l23.42 5.653V21.31L41.25 15.609Z"
        fill="#fff"
      />
      <path d="M32.815 38.358H55.59v1.687H32.815v-1.687Z" fill="url(#n)" />
      <path d="M32.815 38.358H55.59v1.687H32.815v-1.687Z" fill="#fff" />
      <path d="M26.91 36.672H55.59v-1.688H26.911v1.688Z" fill="url(#o)" />
      <path d="M26.91 36.672H55.59v-1.688H26.911v1.688Z" fill="#fff" />
    </g>
    <defs>
      <pattern
        id="b"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .00314 0 -.044)" />
      </pattern>
      <pattern
        id="c"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .0036 0 -.122)" />
      </pattern>
      <pattern
        id="d"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .00314 0 -.044)" />
      </pattern>
      <pattern
        id="e"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .0036 0 -.122)" />
      </pattern>
      <pattern
        id="f"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .00386 0 -.168)" />
      </pattern>
      <pattern
        id="g"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .0036 0 -.122)" />
      </pattern>
      <pattern
        id="h"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .00314 0 -.044)" />
      </pattern>
      <pattern
        id="i"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .00943 0 -1.132)" />
      </pattern>
      <pattern
        id="j"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .05346 0 -8.748)" />
      </pattern>
      <pattern
        id="k"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .00297 0 -.014)" />
      </pattern>
      <pattern
        id="l"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .04245 0 -6.844)" />
      </pattern>
      <pattern
        id="m"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .02024 0 -3.001)" />
      </pattern>
      <pattern
        id="n"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .04245 0 -6.844)" />
      </pattern>
      <pattern
        id="o"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#p" transform="matrix(.00314 0 0 .05346 0 -8.748)" />
      </pattern>
      <clipPath id="a">
        <path fill="#fff" transform="translate(18 16)" d="M0 0h48v48H0z" />
      </clipPath>
      <image
        id="p"
        width={318}
        height={346}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export default WarehouseIcon;
